import '@formatjs/intl-listformat/polyfill';

import '@formatjs/intl-listformat/locale-data/en'; // locale-data for en

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import resourcesToBackend from 'i18next-resources-to-backend';
import {DateTime} from 'luxon';
import {initReactI18next} from 'react-i18next';

import {isDev} from './config.js';

// eslint-disable-next-line import/no-named-as-default-member
i18next
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(intervalPlural)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'en',
    ns: ['common', 'translation'],
    defaultNS: 'translation',
    // fallback, can be a string or an array of namespaces
    fallbackNS: 'common',

    debug: isDev,

    interpolation: {
      escapeValue: false, // not needed for react!!
      format: (value, format, lng) => {
        if (format === 'list') {
          const formatter = new Intl.ListFormat(lng, {
            style: 'long',
            type: 'conjunction',
          });
          return formatter.format(value);
        }
        if (format === 'fromNow') {
          return DateTime.fromISO(value, {zone: 'utc'})
            .setLocale(lng)
            .toRelative();
        }
        return DateTime.fromISO(value, {zone: 'utc'})
          .setLocale(lng)
          .toFormat(format);
      },
    },

    backend: {
      backends: [
        resourcesToBackend((language, namespace, callback) => {
          import(`../locales/${language}/${namespace}.json`)
            .then(({default: resources}) => {
              callback(null, resources);
            })
            .catch(error => {
              callback(error, null);
            });
        }),
      ],
    },
  });

export default i18next;
